import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/functions';
import 'firebase/analytics';

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${process.env.VUE_APP_FIREBASE_PROJECT_ID}.firebaseio.com`,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}.appspot.com`,
  messagingSenderId: process.env.VUE_APP_MESSAGIN_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID
//  measurementId: process.env.VUE_APP_MEASUREMENT_ID
};

firebase.initializeApp(config);

const db = firebase.firestore();
const realtimeDb = firebase.database();
const auth = firebase.auth();
const storage = firebase.storage();
const functions = firebase.functions();
const analytics = firebase.analytics();

if (window.location.hostname === 'localhost') {
  // auth.useEmulator('http://localhost:9999');
  // db.useEmulator('http://localhost:8080');
  functions.useEmulator('localhost', 5001);
  realtimeDb.useEmulator('localhost', 9000);
}

export { firebase, auth, db, realtimeDb, storage, functions, analytics };
